<template>
    <section class="it-hero-wrapper">
        <div class="container-fluid">
            <div class="container">
                <BreadcrumbNode class="d-block d-lg-none" :article="this.$root.breadcrumbData.article" :section="this.$root.breadcrumbData.section"/>
                <div class="row">
                    <div class="col-12">
                        <HeroCard/>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <transition-group name="fade-transition" mode="out-in">
        <div :class="this.classicView ? 'container-fluid' : 'container'" v-if="this.$root.contentTree && this.$root.contentTree.nodes.length > 0" key="content">
            <div style="position:relative; top:-4em" class="row">
                <SearchBar :treeContainer="this.$root"/>
                <hr>
                <transition-group name="fade-transition">
                    <!--classic code view-->
                    <ClassicCodeView v-if="this.classicView" :chunkedNodes="chunkedNodes"/>
                    <!--standard code view-->
                    <StandardCodeView v-else :chunkedNodes="chunkedNodes"/>
                </transition-group>
            </div>
        </div>
        <div v-else key="loading">
            <LoadingModal message="Caricamento del codice in corso..." />
        </div>
    </transition-group>
    <ChatBot/>
</template>

<script>
import BreadcrumbNode from '../navigator/BreadcrumbNode.vue';
import SearchBar from '../navigator/SearchBar.vue';
import HeroCard from '../partials/HeroCard.vue';
import LoadingModal from '../partials/LoadingModal.vue';
import ChatBot from '../partials/ChatBot.vue';
import StandardCodeView from './StandardCodeView.vue';
import ClassicCodeView from './ClassicCodeView.vue';

export default {
    name: "HomeView",
    components: {
        SearchBar,
        HeroCard,
        LoadingModal,
        ChatBot,
        BreadcrumbNode,
        StandardCodeView,
        ClassicCodeView
    },
    data() {
        return {
            classicView: this.getClassicViewFromStorage()
        }
    },
    mounted() {
        this.$root.loadBreadcrumb(null)
    },
    watch: {
        classicView(newValue) {
            this.saveClassicViewToStorage(newValue)
        }
    },
    computed: {
        chunkedNodes() {
            const nodes = this.$root.contentTree.nodes.filter(n => n.activeTitle && !n.filtered)
            const chunkSize = 1 // Cambia qui per il numero di nodi per slide
            const chunks = []
            for (let i = 0; i < nodes.length; i += chunkSize) {
                chunks.push(nodes.slice(i, i + chunkSize))
            }
            return chunks
        }
    },
    methods: {
        getContentTreeChunks() {
            if (this.$root.contentTree !== undefined) {
                return this.$root.contentTree.chunk(this.$root.contentTree.nodes.length/2)
            }
            return [];
        },
        getClassicViewFromStorage() {
            try {
                const stored = localStorage.getItem('classicView')
                return stored !== null ? JSON.parse(stored) : false
            } catch (error) {
                console.warn('Error reading classicView from localStorage:', error)
                return false
            }
        },
        saveClassicViewToStorage(value) {
            try {
                localStorage.setItem('classicView', JSON.stringify(value))
            } catch (error) {
                console.warn('Error saving classicView to localStorage:', error)
            }
        },
        toggleView() {
            this.classicView = !this.classicView
        }
    }
}
</script>